import React from 'react';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';
import { MetaParent } from '../../../../Components/PatientProfile/PatientProfileParts/PatientProfileInformationChildren';
import MagicForm from '../../../../Components/Form/MagicForm';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';
import useNotification from '../../../../Hooks/useNotification.hook';
import useLoading from '../../../Base/Hooks/useLoading';

export interface ParentMetaProfileEditFormValues {
	firstName: string;
	lastName: string;
	phoneNumber: string;
	email: string;
}

interface Props {
	parent: MetaParent;
	childId: string;
	onSuccess: () => void;
}

const FORM_SCHEME: ItemScheme[] = [
	{
		type: MagicField.TEXT_FIELD,
		key: 'firstName',
		title: 'component.patientProfileEdit.firstName',
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.TEXT_FIELD,
		key: 'lastName',
		title: 'component.patientProfileEdit.lastName',
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.PHONE_NUMBER,
		title: 'component.patientProfileEdit.phone',
		key: 'phoneNumber',
	},
	{
		type: MagicField.EMAIL,
		title: 'component.patientProfileEdit.email',
		key: 'email',
	},
];

const MetaParentProfileEdit: React.FC<Props> = ({
	childId,
	parent,
	onSuccess,
}) => {
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();
	const { setIsLoading, isLoading, RenderLoading } = useLoading();

	const handleSubmit = async (values: ParentMetaProfileEditFormValues) => {
		setIsLoading(true);
		try {
			const response = await apiClient.put(
				`/user/${childId}/meta/legalRepresentative`,
				{ key: 'legalRepresentative', value: values },
			);
			if (response.status === 200) {
				showNotificationSuccess({
					content: 'base.shared.userEdited',
				});
				onSuccess();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<MagicForm
			formScheme={FORM_SCHEME}
			defaultValues={parent}
			onSubmit={handleSubmit}
		/>
	);
};

export default MetaParentProfileEdit;
